import { useSelector } from "react-redux";
// import { Permission } from "../../features/home/types/menu-item";

export const useResourcePermissions = (resourceName?: string) => {
  const allPermissions = useSelector(
    (state: any) =>
      state?.session?.userDetails?.roles?.rolePermissions
  );

  const resourcePermissions = allPermissions?.length
    ? allPermissions.find((perm: any) => perm.resource === resourceName)?.permissions
    : [];

  const hasPermission = (permission: string): boolean => {
    return resourcePermissions?.includes(permission) || false;
  };

  const hasAnyPermission = (resource: string, permission?: string) => {
    const resourcePermission = allPermissions?.length
      ? allPermissions?.find((perm: any) => perm.resource === resource)?.permissions
      : [];
    if (permission) {
      return resourcePermission?.includes(permission) || false;
    }
    return resourcePermission;
  };

  return {
    permissions: resourcePermissions,
    hasPermission,
    hasAnyPermission,
    canRead: hasPermission("read"),
    canWrite: hasPermission("write"),
    canDelete: hasPermission("delete"),
  };
};
